/**
 * music.js
 * Lit window.MusicPlayerTracks et window.MusicPlayerConfig injectés par le .liquid
 */

(function () {
  'use strict';

  /* ── Utilitaires ─────────────────────────────────────────────────────── */

  function fmt(secs) {
    var s   = Math.floor(secs);
    var m   = Math.floor(s / 60);
    var sec = s % 60;
    return m + ':' + (sec < 10 ? '0' : '') + sec;
  }

  function qs(id) { return document.getElementById(id); }

  function updateVolGradient(slider) {
    var pct = slider.value + '%';
    slider.style.background =
      'linear-gradient(to right, var(--accent) ' + pct +
      ', rgba(255,255,255,0.18) ' + pct + ')';
  }

  function getDuration() {
    return (audio && !isNaN(audio.duration) && audio.duration > 0)
      ? audio.duration
      : 0;
  }

  function isLightColor(hex) {
    var c = hex.replace('#', '');
    if (c.length === 3) c = c[0]+c[0]+c[1]+c[1]+c[2]+c[2];
    var r = parseInt(c.slice(0,2), 16);
    var g = parseInt(c.slice(2,4), 16);
    var b = parseInt(c.slice(4,6), 16);
    return (r * 299 + g * 587 + b * 114) / 1000 > 128;
  }


  /* ── Config & état ───────────────────────────────────────────────────── */

  var tracks = window.MusicPlayerTracks || [];
  var config = window.MusicPlayerConfig || { autoplay: true, loop: true, accentColor: '#ffffff' };

  var currentIdx  = 0;
  var isPlaying   = false;
  var pendingPlay = false;
  var audio       = null;


  /* ── Éléments DOM ────────────────────────────────────────────────────── */

  var bgEl           = qs('mp-bg');
  var bgNextEl       = qs('mp-bg-next');
  var artworkEl      = qs('mp-artwork');
  var artworkFullEl  = qs('mp-artwork-fullbleed');
  var titleEl    = qs('mp-title');
  var artistEl   = qs('mp-artist');
  var barsEl     = qs('mp-bars');
  var progressEl = qs('mp-progress');
  var fillEl     = qs('mp-fill');
  var thumbEl    = qs('mp-thumb');
  var curEl      = qs('mp-cur');
  var remEl      = qs('mp-rem');
  var playBtn    = qs('mp-play');
  var playIcon   = qs('mp-play-icon');
  var prevBtn    = qs('mp-prev');
  var nextBtn    = qs('mp-next');
  var prevSide   = qs('mp-prev-side');
  var nextSide   = qs('mp-next-side');
  var volSlider  = qs('mp-vol');

  /* Vignettes prev / next */
  var prevCover  = qs('mp-prev-cover');
  var nextCover  = qs('mp-next-cover');
  var prevTitle  = qs('mp-prev-title');
  var nextTitle  = qs('mp-next-title');
  var prevArtist = qs('mp-prev-artist');
  var nextArtist = qs('mp-next-artist');

  /* Vignettes mobile tracklist */
  var trackThumbs = document.querySelectorAll('.mp__track-thumb');


  /* ── Couleur icône play selon luminosité de l'accent ────────────────── */

  function syncPlayIconColor() {
    if (!playBtn) return;
    var light = isLightColor(config.accentColor || '#ffffff');
    playBtn.classList.toggle('mp__play--on-dark',  light);
    playBtn.classList.toggle('mp__play--on-light', !light);
  }


  /* ── Sync icône play + barres animées ───────────────────────────────── */

  function syncPlayButton() {
    if (isPlaying) {
      playIcon.innerHTML =
        '<rect x="6" y="5" width="4" height="14" rx="1"/>' +
        '<rect x="14" y="5" width="4" height="14" rx="1"/>';
      playBtn.setAttribute('aria-label', 'Pause');
    } else {
      playIcon.innerHTML = '<path d="M8 5v14l11-7z"/>';
      playBtn.setAttribute('aria-label', 'Lecture');
    }

    if (barsEl) barsEl.classList.toggle('mp__bars--paused', !isPlaying || pendingPlay);
  }


  /* ── Mise à jour de la barre de progression ──────────────────────────── */

  function updateProgress() {
    var dur = getDuration();
    var cur = audio ? audio.currentTime : 0;
    var pct = dur > 0 ? Math.min((cur / dur) * 100, 100) : 0;

    fillEl.style.width = pct + '%';
    thumbEl.style.left = pct + '%';
    curEl.textContent  = fmt(cur);
    remEl.textContent  = dur > 0 ? '-' + fmt(Math.max(dur - cur, 0)) : '-0:00';
  }


  /* ── Tentative de lecture (gestion autoplay policy) ──────────────────── */

  function attemptPlay() {
    if (!audio) return;
    audio.play().catch(function () {
      isPlaying   = false;
      pendingPlay = true;
      syncPlayButton();
    });
  }


  /* ── Mise à jour de l'état actif dans la tracklist mobile ───────────── */

  function updateActiveThumb(idx) {
    for (var i = 0; i < trackThumbs.length; i++) {
      trackThumbs[i].classList.toggle('is-active', i === idx);
    }
  }


  /* ── Mise à jour des vignettes prev / next ───────────────────────────── */

  function updateNeighbors(idx) {
    if (!tracks.length) return;
    var prevIdx = (idx - 1 + tracks.length) % tracks.length;
    var nextIdx = (idx + 1) % tracks.length;
    var p = tracks[prevIdx];
    var n = tracks[nextIdx];

    if (prevTitle)  prevTitle.textContent  = p.name;
    if (prevArtist) prevArtist.textContent = p.artist;
    if (prevCover) {
      if (p.img) { prevCover.src = p.img; prevCover.style.display = 'block'; }
      else        { prevCover.style.display = 'none'; }
    }

    if (nextTitle)  nextTitle.textContent  = n.name;
    if (nextArtist) nextArtist.textContent = n.artist;
    if (nextCover) {
      if (n.img) { nextCover.src = n.img; nextCover.style.display = 'block'; }
      else        { nextCover.style.display = 'none'; }
    }
  }


  /* ── Audio ───────────────────────────────────────────────────────────── */

  function setupAudio(url) {
    if (!url) return;

    if (audio) { audio.pause(); audio.src = ''; }

    audio = new Audio(url);
    audio.volume = volSlider ? parseInt(volSlider.value, 10) / 100 : 0.75;

    audio.addEventListener('timeupdate',     updateProgress);
    audio.addEventListener('loadedmetadata', updateProgress);

    audio.addEventListener('ended', function () {
      if (config.loop || currentIdx < tracks.length - 1) {
        nextTrack();
      } else {
        isPlaying = false;
        syncPlayButton();
      }
    });

    audio.addEventListener('pause', function () {
      if (isPlaying) { isPlaying = false; syncPlayButton(); }
    });

    audio.addEventListener('play', function () {
      if (!isPlaying) { isPlaying = true; syncPlayButton(); }
    });

    if (isPlaying) attemptPlay();
  }


  /* ── Charger un morceau ──────────────────────────────────────────────── */

  function loadTrack(idx, skipTransition) {
    if (!tracks.length) return;

    var t  = tracks[idx];
    currentIdx = idx;

    titleEl.textContent  = t.name;
    artistEl.textContent = t.artist + ' — ' + t.album;

    updateNeighbors(idx);
    updateActiveThumb(idx);

    /* Transition douce cover */
    if (artworkEl) {
      if (skipTransition) {
        artworkEl.src = t.img || '';
        artworkEl.alt = t.name;
      } else {
        var newSrc = t.img || '';
        var newAlt = t.name;
        var preload = new Image();
        preload.onload = preload.onerror = function () {
          artworkEl.classList.add('is-changing');
          if (artworkFullEl) artworkFullEl.classList.add('is-changing');
          setTimeout(function () {
            artworkEl.src = newSrc;
            artworkEl.alt = newAlt;
            artworkEl.classList.remove('is-changing');
            if (artworkFullEl) {
              artworkFullEl.src = newSrc;
              artworkFullEl.classList.remove('is-changing');
            }
          }, 250);
        };
        preload.src = newSrc;
      }
    }

    if (artworkFullEl && skipTransition) {
      artworkFullEl.src = t.img || '';
    }

    if (bgEl && t.img) {
      var newBg = "url('" + t.img + "')";
      if (skipTransition) {
        bgEl.style.backgroundImage = newBg;
        if (bgNextEl) { bgNextEl.style.backgroundImage = newBg; bgNextEl.classList.remove('is-fading-in'); }
      } else if (bgNextEl) {
        bgNextEl.classList.remove('is-fading-in');
        bgNextEl.style.backgroundImage = newBg;
        void bgNextEl.offsetWidth;
        bgNextEl.classList.add('is-fading-in');
        setTimeout(function () {
          bgEl.style.backgroundImage = newBg;
          bgNextEl.classList.remove('is-fading-in');
        }, 700);
      } else {
        bgEl.style.backgroundImage = newBg;
      }
    }

    updateProgress();
    syncPlayButton();
    setupAudio(t.audio);
  }


  /* ── Play / Pause ────────────────────────────────────────────────────── */

  function setPlaying(state) {
    isPlaying = state;
    syncPlayButton();
    if (state) {
      attemptPlay();
    } else {
      if (audio) audio.pause();
    }
  }

  function togglePlay() { setPlaying(!isPlaying); }


  /* ── Navigation ──────────────────────────────────────────────────────── */

  function nextTrack() {
    var nextIdx = (currentIdx + 1) % tracks.length;
    if (!config.loop && nextIdx === 0 && currentIdx === tracks.length - 1) {
      isPlaying = false;
      syncPlayButton();
      return;
    }
    loadTrack(nextIdx);
  }

  function prevTrack() {
    if (audio && audio.currentTime > 3) {
      audio.currentTime = 0;
      updateProgress();
      return;
    }
    loadTrack((currentIdx - 1 + tracks.length) % tracks.length);
  }


  /* ── Seek ─────────────────────────────────────────────────────────────── */

  function seek(e) {
    var dur = getDuration();
    if (!dur || !audio) return;
    var rect = progressEl.getBoundingClientRect();
    var pct  = Math.max(0, Math.min(1, (e.clientX - rect.left) / rect.width));
    audio.currentTime = pct * dur;
    updateProgress();
  }


  /* ── Autoplay policy : attendre la première interaction ─────────────── */

  function onFirstInteraction() {
    if (!pendingPlay || !audio) return;
    pendingPlay = false;
    isPlaying   = true;
    audio.play().catch(function () { isPlaying = false; });
    syncPlayButton();
    ['click', 'touchstart', 'keydown'].forEach(function (evt) {
      document.removeEventListener(evt, onFirstInteraction);
    });
  }

  ['click', 'touchstart', 'keydown'].forEach(function (evt) {
    document.addEventListener(evt, onFirstInteraction, { passive: true });
  });


  /* ── Événements ──────────────────────────────────────────────────────── */

  if (playBtn)  playBtn.addEventListener('click', togglePlay);
  if (prevBtn)  prevBtn.addEventListener('click', prevTrack);
  if (nextBtn)  nextBtn.addEventListener('click', nextTrack);
  if (prevSide) prevSide.addEventListener('click', prevTrack);
  if (nextSide) nextSide.addEventListener('click', nextTrack);

  if (volSlider) {
    updateVolGradient(volSlider);
    volSlider.addEventListener('input', function () {
      updateVolGradient(this);
      if (audio) audio.volume = parseInt(this.value, 10) / 100;
    });
  }

  if (progressEl) {
    progressEl.addEventListener('click', seek);
    progressEl.addEventListener('keydown', function (e) {
      var dur = getDuration();
      if (!audio || !dur) return;
      if (e.key === 'ArrowRight') audio.currentTime = Math.min(audio.currentTime + 5, dur);
      if (e.key === 'ArrowLeft')  audio.currentTime = Math.max(audio.currentTime - 5, 0);
      updateProgress();
    });
  }

  document.addEventListener('keydown', function (e) {
    if (e.target.tagName === 'INPUT' || e.target.tagName === 'TEXTAREA') return;
    if (e.key === ' ')                      { e.preventDefault(); togglePlay(); }
    if (e.key === 'ArrowRight' && e.altKey) nextTrack();
    if (e.key === 'ArrowLeft'  && e.altKey) prevTrack();
  });


  /* ── Vignettes tracklist mobile ─────────────────────────────────────── */

  for (var i = 0; i < trackThumbs.length; i++) {
    (function (btn, idx) {
      btn.addEventListener('click', function () {
        isPlaying = true;
        loadTrack(idx);
      });
    })(trackThumbs[i], i);
  }


  /* ── Init ────────────────────────────────────────────────────────────── */

  if (tracks.length) {
    syncPlayIconColor();
    if (config.autoplay) {
      isPlaying   = true;
      pendingPlay = true;
    }
    loadTrack(0, true);
  }

})();